export const partnershipArray = [
    {
        header: "Free installation and maintenance: ",
        text: "We take care of everything from installing the air compressors to servicing them regularly. You don’t have to worry about any upfront or ongoing costs."
    },
    {
        header: "Card readers on all machines: ",
        text: "We equip all of our air compressors with card readers, so your customers can pay with their credit or debit cards. This increases the convenience and security for both you and your customers."
    }
]